import {fetch} from "utils/dataAccess";

export function cancelItem(item, reason) {
    return new Promise((resolve, reject) => {
        fetch(`line_items/${item.id}/cancellation-reason`, {
            method: 'PUT',
            headers: new Headers({'Content-Type': 'application/ld+json'}),
            body: JSON.stringify({
                reason: reason
            })
        })
            .then(response => {
            response.json().then(retrieved => {
                resolve(retrieved)
            })
        })
            .catch(error => reject(error))
    })
}